import { useState, useEffect } from 'react';
import api from '../../services/api';
import { Load } from '../../components/Load';
import { Header } from '../../components/Header';
import { Sidebar } from '../../components/Sidebar';
import { Main } from '../../components/Main';
import { CardContent } from '../../components/CardContent';
import { Button, Col, Row, Modal as Modals, Spinner } from 'react-bootstrap';
import { Eye, ExclamationTriangleFill, Pencil, CheckCircleFill, Search, BoxArrowUp } from 'react-bootstrap-icons';
import './style.css';
import AlertMessage from '../../components/Alert';
import { Title } from '../../components/Title';
import { Grid } from '@mui/material';


export function ReaproveitamentoAdm() {
    const [isLoading, setIsLoading] = useState(true);
    const [isLoadingPayment, setIsLoadingPayment] = useState(false);
    const [alert, setAlert] = useState({ show: false, message: '', variant: 'success' });
    const [selectedCheckboxTables, setSelectedCheckBoxTables] = useState<any>([]);
    const [asosReaproveitados, setAsosReaproveitados]: any = useState([]);
    const [funcoesReaproveitamento, setFuncoesReaproveitamento] = useState<any>([]);
    const [tabelaAtiva, setTabelaAtiva] = useState('tabela1');
    const [asosEmpresa, setAsosEmpresas] = useState([])
    const [searchTerm, setSearchTerm] = useState('');
    const [searchTermEmpresa, setSearchTermEmpresa] = useState('');
    const [filterStatus, setFilterStatus] = useState('Todos');
    const [filterEnviadoPor, setFilterEnviadoPor] = useState('Todos')
    const [filterStatusEmpresa, setFilterStatusEmpresa] = useState('Todos')
    const [showModal, setShowModal] = useState(false);
    const [funcoes, setFuncoes] = useState<any>([]);
    const [funcaoSelecionada, setFuncaoSelecionada] = useState<any>();
    const [trabalhadorId, setTrabalhadorId] = useState<number>(0);
    const [exames, setExames] = useState<any>([]);
    const [reapPcmso, setReapPcmso] = useState<any>([]);

    function handleClose(){
        setShowModal(false);
        setFuncoes([]);
        setFuncaoSelecionada(null);
        setTrabalhadorId(0);
        setExames([]);
    } 

    useEffect(() => {
        loadReaproveitamentos();
        loadReaproveitamentosEmpresa();
    }, []);

    const filteredAsos = asosReaproveitados.filter((reap: any) =>
        (filterStatus === 'Todos' ||
            (filterStatus === 'Quarentena' && reap.liberado === 0) ||
            (filterStatus === 'Liberado' && reap.liberado === 1)
        ) &&
        (filterEnviadoPor === 'Todos' ||
            (filterEnviadoPor === 'Trabalhador' && !reap.pgrEmpresa) ||
            (filterEnviadoPor === 'Empresa' && reap.pgrEmpresa)
        ) &&
        (reap.pgrTrabalhador.cpf.includes(searchTerm) ||
            reap.pgrTrabalhador.nome.toLowerCase().includes(searchTerm.toLowerCase()))
    );

    const filteredAsosLiberados = asosReaproveitados.filter((reap: any) => {
        // Verificação se o exame já foi liberado
        const isLiberado = reap.liberado === 1;
    
        return (
            isLiberado && // Adicionando essa verificação para garantir que só os liberados sejam exibidos
            (filterStatus === 'Todos' ||
                (filterStatus === 'Quarentena' && reap.liberado === 0) ||
                (filterStatus === 'Liberado' && isLiberado)
            ) &&
            (filterEnviadoPor === 'Todos' ||
                (filterEnviadoPor === 'Trabalhador' && !reap.pgrEmpresa) ||
                (filterEnviadoPor === 'Empresa' && reap.pgrEmpresa)
            ) &&
            (reap.pgrTrabalhador.cpf.includes(searchTerm) ||
                reap.pgrTrabalhador.nome.toLowerCase().includes(searchTerm.toLowerCase()))
        );
    })

    const filteredAsosEmpresa = asosEmpresa.filter((reap: any) => {
        const empresaNome = reap.empresa?.nome?.toLowerCase() || '';
        const empresaCnpj = reap.empresa?.cnpj || '';
    
        return (
            (filterStatusEmpresa === 'Todos' ||
                (filterStatusEmpresa === 'Quarentena' && (reap.liberado === 0 && reap.assinado_trabalhador === 0)) ||
                (filterStatusEmpresa === 'Finalizado' && (reap.liberado === 1 && reap.assinado_trabalhador === 1)) ||
                (filterStatusEmpresa === 'Aguardando assinatura' && (reap.liberado === 1 && reap.assinado_trabalhador === 0))
            ) &&
            (empresaNome.includes(searchTermEmpresa.toLowerCase()) || empresaCnpj.includes(searchTermEmpresa))
        );
    })
    
    
    const handleMostrarTabela1 = () => {
        setTabelaAtiva('tabela1');
    };
    
    const handleMostrarTabela2 = () => {
        setTabelaAtiva('tabela2');
    };
    
    const handleMostrarTabela3 = () => {
        setTabelaAtiva('tabela3');
    };

    const handleMostrarTabela4 = () => {
        setTabelaAtiva('tabela4');
    };
    
    const formatDate = (isoDate: any) => {
        const date = new Date(isoDate);
        
        const day = String(date.getUTCDate()).padStart(2, '0');
        const month = String(date.getUTCMonth() + 1).padStart(2, '0'); 
        const year = date.getUTCFullYear();
        
        const hours = String(date.getUTCHours()).padStart(2, '0');
        const minutes = String(date.getUTCMinutes()).padStart(2, '0');
        const seconds = String(date.getUTCSeconds()).padStart(2, '0');
        
        return `${day}/${month}/${year} às ${hours}:${minutes}:${seconds}`;
    }
    
    const loadReaproveitamentos = async () => {
        try {
            const dados = await api.get(`listar-asos-assinados`);
            setAsosReaproveitados(dados.data.listaAsos.asosAssinados);
            setFuncoesReaproveitamento(dados.data.listaAsos.funcoes)
        } catch (error) {
            console.error("Erro ao buscar reaproveitamentos:", error);
        } finally {
            setIsLoading(false);
        }
    };
    
    const loadReaproveitamentosEmpresa = async () => {
        try {
            const response = await api.post('buscar-reaproveitamento-aso')
            setAsosEmpresas(response.data.reaproveitamento)
        } catch (error) {
            console.error(error)
        } finally {
            setIsLoading(false)
        }
    }
    
    async function visualizarTrabalhador(trabalhadorSelecionadoId:number) {
        try {
            const response = await api.get(`buscar-funcoes-trabalhador/${trabalhadorSelecionadoId}`);
            const responseData = response.data;
            setTrabalhadorId(trabalhadorSelecionadoId);
            setShowModal(true);
            setFuncoes(responseData);
            
        } catch (error) {
            console.error(error);
        }
    }
    
    const handleSelectFuncao = (funcao: any) => {
        setFuncaoSelecionada(funcao.ateBaseFuncao);
    };
    
    async function handleEmitirPagamentoTrabalhador() {
        try {
            setIsLoadingPayment(true);
            await api.post(`emitir-reaproveitamento-aso-trabalhador/${trabalhadorId}/${funcaoSelecionada.id}`);
            setAlert({ show: true, message: 'Pagamento emitido com sucesso!', variant: 'success' });
            handleClose();
        } catch (error) {
            console.error("Erro ao emitir pagamento:", error);
            setAlert({ show: true, message: 'Erro ao emitir pagamento. Tente novamente.', variant: 'danger' });
        } finally {
            setIsLoadingPayment(false);
        }
    }
    
    const transformarPreco = (valor: any) => {
        const valorDividido = valor / 100;
        return valorDividido.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    };
    
    
    const fetchExams = async () => {
        try {
            const response = await api.get(`buscar-dados-aso-pronto/${trabalhadorId}/${funcaoSelecionada.id}`)
            const responseData = response.data;
            setExames(responseData.examesTrabalhadorAtual);
        } catch (error) {
            console.error(error);
        }
    }

    const listarTodosOsDocumentos = async () => {
        const response = await api.get('buscar-reaproveitamentos-pcmso');
        setReapPcmso(response.data.data.reaproveitamentosPcmso);
    }

    useEffect(() => {
        listarTodosOsDocumentos();
    }, []);
    
    useEffect(() => {
        if (funcaoSelecionada) {
            fetchExams();   
        }
    }, [funcaoSelecionada])

    return (
        <div>
            <Load isLoading={isLoading} />
            <Sidebar />
            <Header route='./' />
            <Main>
                <CardContent>
                    <Row className='mb-4'>
                        <Title text="Acompanhamento de Reaproveitamentos" />
                    </Row>
                    <Row>
                        <Row className="d-flex justify-content-center mb-4">
                            <Col xs="auto" className="text-center">
                                <Title text="Selecione o que deseja visualizar:" />
                            </Col>
                        </Row>
                        <Row>
                            <Col className="d-flex justify-content-center mb-4">
                                <Button
                                    variant={tabelaAtiva === 'tabela1' ? 'primary' : 'outline-primary'}
                                    onClick={handleMostrarTabela1}
                                    className="me-2"
                                >
                                    Trabalhadores pendentes de liberação
                                </Button>
                                <Button
                                    variant={tabelaAtiva === 'tabela2' ? 'primary' : 'outline-primary'}
                                    onClick={handleMostrarTabela2}
                                    className='me-2'
                                >
                                    ASOS para Revisão
                                </Button>
                                <Button
                                    variant={tabelaAtiva === 'tabela3' ? 'primary' : 'outline-primary'}
                                    onClick={handleMostrarTabela3}
                                    className='me-2'
                                >
                                    ASOS Prontos
                                </Button>
                                <Button
                                    variant={tabelaAtiva === 'tabela4' ? 'primary' : 'outline-primary'}
                                    onClick={handleMostrarTabela4}
                                    className='me-2'
                                >
                                    PCMSOs para reaproveitamento
                                </Button>
                            </Col>
                        </Row>
                        <Col md={12}>
                            {tabelaAtiva === 'tabela1' && (
                                <>
                                    <Row style={{ marginBottom: '20px', justifyContent: 'center' }}>
                                        {/* Busca por CPF com lupa */}
                                        <Col xs="auto">
                                            <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                                                <Search
                                                    style={{
                                                        position: 'absolute',
                                                        top: '50%',
                                                        left: '20px',
                                                        transform: 'translateY(-50%)',
                                                        color: '#6c757d',
                                                        fontSize: '18px',
                                                    }}
                                                />
                                                <input
                                                    type="text"
                                                    placeholder="Buscar por CPF ou Nome"
                                                    value={searchTerm}
                                                    onChange={(e) => setSearchTerm(e.target.value)}
                                                    style={{
                                                        padding: '10px 10px 10px 40px',
                                                        width: '300px',
                                                        borderRadius: '5px',
                                                        border: '1px solid #0d6efd'
                                                    }}
                                                />
                                            </div>
                                        </Col>


                                        <Col xs="auto">
                                            <label
                                                htmlFor=""
                                                style={{
                                                    fontSize: '16px',
                                                    marginRight: '10px',
                                                }}
                                            >
                                                Status:
                                            </label>
                                            <select
                                                value={filterStatus}
                                                onChange={(e) => setFilterStatus(e.target.value)}
                                                style={{
                                                    padding: '10px',
                                                    width: '200px',
                                                    borderRadius: '5px',
                                                    border: '1px solid #0d6efd',
                                                    fontSize: '16px',
                                                }}
                                            >
                                                <option value="Todos">Todos</option>
                                                <option value="Quarentena">Quarentena</option>
                                                <option value="Liberado">Liberado</option>
                                            </select>
                                        </Col>

                                        <Col xs="auto">
                                            <label
                                                htmlFor=""
                                                style={{
                                                    fontSize: '16px',
                                                    marginRight: '10px', 
                                                }}
                                            >
                                                Enviado por:
                                            </label>
                                            <select
                                                value={filterEnviadoPor}
                                                onChange={(e) => setFilterEnviadoPor(e.target.value)}
                                                style={{
                                                    padding: '10px',
                                                    width: '200px',
                                                    borderRadius: '5px',
                                                    border: '1px solid #0d6efd',
                                                    fontSize: '16px',
                                                }}
                                            >
                                                <option value="Todos">Todos</option>
                                                <option value="Trabalhador">Trabalhador</option>
                                                <option value="Empresa">Empresa</option>
                                            </select>
                                        </Col>

                                    </Row>

                                    <Row style={{ display: 'flex', justifyContent: 'center', overflowX: 'auto', width: '100%', borderRadius: '6px', border: '1px solid #0d6efd' }}>
                                        <table >
                                            <thead>
                                                <tr style={{ backgroundColor: '#0d6efd', color: 'white' }}>
                                                    <th style={{ fontSize: '14px', padding: '15px', fontWeight: 'normal' }}>CÓD</th>
                                                    <th style={{ fontSize: '14px', padding: '15px', fontWeight: 'normal', maxWidth: '150px', wordWrap: 'break-word' }}>
                                                        Enviado por
                                                    </th>
                                                    <th style={{ fontSize: '14px', padding: '15px', fontWeight: 'normal' }}>FUNCIONÁRIO</th>
                                                    <th style={{ fontSize: '14px', padding: '15px', fontWeight: 'normal' }}>FUNÇÕES SUGERIDAS</th>
                                                    <th style={{ fontSize: '14px', padding: '15px', fontWeight: 'normal' }}>CADASTRO</th>
                                                    <th style={{ fontSize: '14px', padding: '15px', fontWeight: 'normal' }}>STATUS</th>
                                                    <th style={{ fontSize: '14px', padding: '15px', fontWeight: 'normal' }}>AÇÕES</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {filteredAsos && filteredAsos.length > 0 ? (
                                                    filteredAsos.map((reap: any, index: number) => {
                                                        return (
                                                            <tr key={reap.id}>
                                                                <td style={{ fontSize: '13px', padding: '15px', fontWeight: 'bold' }}>
                                                                    {reap.id}
                                                                </td>
                                                                <td style={{ fontSize: '13px', padding: '15px', fontWeight: 'bold', maxWidth: '150px', wordWrap: 'break-word' }}>
                                                                    {reap.pgrEmpresa ? (
                                                                        <>
                                                                            Empresa: {reap.pgrEmpresa?.nome}
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            Trabalhador
                                                                        </>
                                                                    )}
                                                                </td>
                                                                <td style={{ fontSize: '13px', padding: '15px', fontWeight: 'bold' }}>
                                                                    {reap.pgrTrabalhador.nome}
                                                                    <div style={{ fontSize: '13px', color: '#777', marginTop: '5px', fontWeight: 'bold' }}>
                                                                        CPF: {reap.pgrTrabalhador.cpf}
                                                                    </div>
                                                                </td>
                                                                <td style={{ fontSize: '11px', padding: '15px', fontWeight: 'bold' }}>
                                                                    {
                                                                        funcoesReaproveitamento
                                                                            .filter((funcao: any) => funcao.index_aso === reap.id)
                                                                            .map((funcao: any) => funcao.nomes)
                                                                            .join(', ') || 'Nenhuma função encontrada'
                                                                    }
                                                                </td>
                                                                <td style={{ fontSize: '13px', padding: '15px', fontWeight: 'bold' }}>
                                                                    {formatDate(reap.created_at)}
                                                                </td>
                                                                <td style={{ fontSize: '13px', padding: '15px', fontWeight: 'bold', color: reap.liberado ? 'green' : 'red' }}>
                                                                    {reap.liberado ? (
                                                                        <>
                                                                            <CheckCircleFill style={{ marginBottom: '5px' }} /> Liberado
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            <ExclamationTriangleFill style={{ marginBottom: '5px' }} /> Quarentena
                                                                        </>
                                                                    )}
                                                                </td>
                                                                <td style={{ fontSize: '13px', padding: '15px', fontWeight: 'bold', display: 'inline-flex', gap: '10px' }}>
                                                                    <Button href={`/reaproveitamentos/editar-trabalhador/${reap.id}`} variant="primary">
                                                                        {reap.liberado ? (
                                                                            <>
                                                                                <Eye size={20} />
                                                                            </>
                                                                        ) : (
                                                                            <>
                                                                                <Pencil size={20} />
                                                                            </>
                                                                        )}

                                                                    </Button>
                                                                </td>
                                                            </tr>
                                                        );
                                                    })
                                                ) : (
                                                    <tr>
                                                        <td style={{ padding: '15px' }}>
                                                            Nenhum reaproveitamento disponível
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </Row>
                                </>)
                            }

                            {tabelaAtiva === 'tabela2' && (
                                <>
                                    <Row style={{ marginBottom: '20px', justifyContent: 'center' }}>
                                        <Col xs="auto">
                                            <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                                                <Search
                                                    style={{
                                                        position: 'absolute',
                                                        top: '50%',
                                                        left: '20px',
                                                        transform: 'translateY(-50%)',
                                                        color: '#6c757d',
                                                        fontSize: '18px',
                                                    }}
                                                />
                                                <input
                                                    type="text"
                                                    placeholder="Buscar por nome ou CNPJ"
                                                    value={searchTermEmpresa}
                                                    onChange={(e) => setSearchTermEmpresa(e.target.value)}
                                                    style={{
                                                        padding: '10px 10px 10px 40px',
                                                        width: '300px',
                                                        borderRadius: '5px',
                                                        border: '1px solid #0d6efd'
                                                    }}
                                                />
                                            </div>
                                        </Col>

                                        <Col xs="auto">
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <div style={{ marginRight: '10px' }}>
                                                    <label
                                                        htmlFor="statusFilter"
                                                        style={{ fontSize: '16px' }}
                                                    >
                                                        Status:
                                                    </label>
                                                </div>
                                                <div style={{ flex: 1 }}>
                                                    <select
                                                        id="statusFilter"
                                                        value={filterStatusEmpresa}
                                                        onChange={(e) => setFilterStatusEmpresa(e.target.value)}
                                                        style={{
                                                            padding: '10px',
                                                            width: '250px',
                                                            borderRadius: '5px',
                                                            border: '1px solid #0d6efd',
                                                            fontSize: '16px',
                                                        }}
                                                    >
                                                        <option value="Todos">Todos</option>
                                                        <option value="Quarentena">Quarentena</option>
                                                        <option value="Finalizado">Finalizado</option>
                                                        <option value="Aguardando assinatura">Aguardando assinatura</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>

                                    <Row style={{ display: 'flex', justifyContent: 'center', overflowX: 'auto', width: '100%', borderRadius: '6px', border: '1px solid #0d6efd' }}>
                                        <table >
                                            <thead>
                                                <tr style={{ backgroundColor: '#0d6efd', color: 'white' }}>
                                                    <th style={{ fontSize: '14px', padding: '15px', fontWeight: 'normal' }}>CÓD</th>
                                                    <th style={{ fontSize: '14px', padding: '15px', fontWeight: 'normal' }}>EMPRESA</th>
                                                    <th style={{ fontSize: '14px', padding: '15px', fontWeight: 'normal' }}>FUNCIONÁRIO</th>
                                                    <th style={{ fontSize: '14px', padding: '15px', fontWeight: 'normal' }}>FUNÇÃO ATRIBUÍDA</th>
                                                    <th style={{ fontSize: '14px', padding: '15px', fontWeight: 'normal' }}>CADASTRO</th>
                                                    <th style={{ fontSize: '14px', padding: '15px', fontWeight: 'normal' }}>STATUS</th>
                                                    <th style={{ fontSize: '14px', padding: '15px', fontWeight: 'normal' }}>AÇÕES</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {filteredAsosEmpresa && filteredAsosEmpresa.length > 0 ? (
                                                    filteredAsosEmpresa.map((reap: any, index: number) => {
                                                        return (
                                                            <tr key={reap.id}>
                                                                <td style={{ fontSize: '13px', padding: '15px', fontWeight: 'bold' }}>
                                                                    {reap.id}
                                                                </td>
                                                                <td style={{ fontSize: '13px', padding: '15px', fontWeight: 'bold' }}>
                                                                    {reap.empresa ? reap.empresa.nome : 'Empresa não disponível'}

                                                                    <div style={{ fontSize: '13px', color: '#777', marginTop: '5px', fontWeight: 'bold' }}>
                                                                        CNPJ: {reap.empresa ? reap.empresa.cnpj : 'CNPJ não disponível'}
                                                                    </div>
                                                                </td>
                                                                <td style={{ fontSize: '13px', padding: '15px', fontWeight: 'bold' }}>
                                                                    {reap.pgrTrabalhador.nome}
                                                                </td>
                                                                <td style={{ fontSize: '13px', padding: '15px', fontWeight: 'bold' }}>
                                                                    {reap.funcao.nome}
                                                                </td>
                                                                <td style={{ fontSize: '13px', padding: '15px', fontWeight: 'bold' }}>
                                                                    {formatDate(reap.created_at)}
                                                                </td>
                                                                <td style={{ fontSize: '13px', padding: '15px', fontWeight: 'bold', color: reap.liberado ? (reap.assinado_trabalhador ? 'green' : '#FFA500') : 'red' }}>
                                                                    {reap.liberado ? (
                                                                        reap.assinado_trabalhador ? (
                                                                            <>
                                                                                <CheckCircleFill style={{ marginBottom: '5px' }} /> Documento finalizado
                                                                            </>
                                                                        ) : (
                                                                            <>
                                                                                <ExclamationTriangleFill style={{ marginBottom: '5px' }} /> Aguardando assinatura do Trabalhador
                                                                            </>
                                                                        )
                                                                    ) : (
                                                                        <>
                                                                            <ExclamationTriangleFill style={{ marginBottom: '5px' }} /> Quarentena
                                                                        </>
                                                                    )}
                                                                </td>
                                                                <td style={{ fontSize: '13px', padding: '15px', fontWeight: 'bold', display: 'inline-flex', gap: '10px' }}>
                                                                    <Button href={`/reaproveitamentos/editar-empresa/${reap.id}`} variant="primary">
                                                                        {reap.liberado ? (
                                                                            <>
                                                                                <Eye size={20} />
                                                                            </>
                                                                        ) : (
                                                                            <>
                                                                                <Pencil size={20} />
                                                                            </>
                                                                        )}

                                                                    </Button>
                                                                </td>
                                                            </tr>
                                                        );
                                                    })
                                                ) : (
                                                    <tr>
                                                        <td style={{ padding: '15px' }}>
                                                            Nenhum reaproveitamento disponível
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </Row>
                                </>
                            )}

                            {tabelaAtiva === 'tabela3' && (
                               <>
                                    <Row style={{ marginBottom: '20px', justifyContent: 'center' }}>
                                        {/* Busca por CPF com lupa */}
                                        <Col xs="auto">
                                            <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                                                <Search
                                                    style={{
                                                        position: 'absolute',
                                                        top: '50%',
                                                        left: '20px',
                                                        transform: 'translateY(-50%)',
                                                        color: '#6c757d',
                                                        fontSize: '18px',
                                                    }}
                                                />
                                                <input
                                                    type="text"
                                                    placeholder="Buscar por CPF ou Nome"
                                                    value={searchTerm}
                                                    onChange={(e) => setSearchTerm(e.target.value)}
                                                    style={{
                                                        padding: '10px 10px 10px 40px',
                                                        width: '300px',
                                                        borderRadius: '5px',
                                                        border: '1px solid #0d6efd'
                                                    }}
                                                />
                                            </div>
                                        </Col>


                                        <Col xs="auto">
                                            <label
                                                htmlFor=""
                                                style={{
                                                    fontSize: '16px',
                                                    marginRight: '10px', 
                                                }}
                                            >
                                                Enviado por:
                                            </label>
                                            <select
                                                value={filterEnviadoPor}
                                                onChange={(e) => setFilterEnviadoPor(e.target.value)}
                                                style={{
                                                    padding: '10px',
                                                    width: '200px',
                                                    borderRadius: '5px',
                                                    border: '1px solid #0d6efd',
                                                    fontSize: '16px',
                                                }}
                                            >
                                                <option value="Todos">Todos</option>
                                                <option value="Trabalhador">Trabalhador</option>
                                                <option value="Empresa">Empresa</option>
                                            </select>
                                        </Col>

                                    </Row>

                                    <Row style={{ display: 'flex', justifyContent: 'center', overflowX: 'auto', width: '100%', borderRadius: '6px', border: '1px solid #0d6efd' }}>
                                        <table >
                                            <thead>
                                                <tr style={{ backgroundColor: '#0d6efd', color: 'white' }}>
                                                    <th style={{ fontSize: '14px', padding: '15px', fontWeight: 'normal' }}>CÓD</th>
                                                    <th style={{ fontSize: '14px', padding: '15px', fontWeight: 'normal', maxWidth: '150px', wordWrap: 'break-word' }}>
                                                        Enviado por
                                                    </th>
                                                    <th style={{ fontSize: '14px', padding: '15px', fontWeight: 'normal' }}>FUNCIONÁRIO</th>
                                                    <th style={{ fontSize: '14px', padding: '15px', fontWeight: 'normal' }}>FUNÇÕES SUGERIDAS</th>
                                                    <th style={{ fontSize: '14px', padding: '15px', fontWeight: 'normal' }}>CADASTRO</th>
                                                    <th style={{ fontSize: '14px', padding: '15px', fontWeight: 'normal' }}>AÇÕES</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {filteredAsosLiberados && filteredAsosLiberados.length > 0 ? (
                                                    filteredAsosLiberados.map((reap: any, index: number) => {
                                                        return (
                                                            <tr key={reap.id}>
                                                                <td style={{ fontSize: '13px', padding: '15px', fontWeight: 'bold' }}>
                                                                    {reap.id}
                                                                </td>
                                                                <td style={{ fontSize: '13px', padding: '15px', fontWeight: 'bold', maxWidth: '150px', wordWrap: 'break-word' }}>
                                                                    {reap.pgrEmpresa ? (
                                                                        <>
                                                                            Empresa: {reap.pgrEmpresa?.nome}
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            Trabalhador
                                                                        </>
                                                                    )}
                                                                </td>
                                                                <td style={{ fontSize: '13px', padding: '15px', fontWeight: 'bold' }}>
                                                                    {reap.pgrTrabalhador.nome}
                                                                    <div style={{ fontSize: '13px', color: '#777', marginTop: '5px', fontWeight: 'bold' }}>
                                                                        CPF: {reap.pgrTrabalhador.cpf}
                                                                    </div>
                                                                </td>
                                                                <td style={{ fontSize: '11px', padding: '15px', fontWeight: 'bold' }}>
                                                                    {
                                                                        funcoesReaproveitamento
                                                                            .filter((funcao: any) => funcao.index_aso === reap.id)
                                                                            .map((funcao: any) => funcao.nomes)
                                                                            .join(', ') || 'Nenhuma função encontrada'
                                                                    }
                                                                </td>
                                                                <td style={{ fontSize: '13px', padding: '15px', fontWeight: 'bold' }}>
                                                                    {formatDate(reap.created_at)}
                                                                </td>
                                                               
                                                                <td style={{ fontSize: '13px', padding: '15px', fontWeight: 'bold', display: 'inline-flex', gap: '10px' }}>
                                                                    <Button onClick={() => visualizarTrabalhador(reap.pgrTrabalhador.id)} variant="primary">
                                                                        <BoxArrowUp size={20} />
                                                                    </Button>
                                                                </td>
                                                            </tr>
                                                        );
                                                    })
                                                ) : (
                                                    <tr>
                                                        <td style={{ padding: '15px' }}>
                                                            Nenhum reaproveitamento disponível
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </Row>
                                </>
                            )}
                            {tabelaAtiva === 'tabela4' && (
                                <>
                                    <Row className='mb-4'>
                                    </Row>
                                    <Row style={{ display: 'flex', justifyContent: 'center', overflowX: 'auto', width: '100%', borderRadius: '6px', border: '1px solid #0d6efd' }}>
                                        <table>
                                            
                                            <thead>
                                                <tr style={{ backgroundColor: '#0d6efd', color: 'white' }}>
                                                    <th style={{ fontSize: '14px', padding: '15px', fontWeight: 'normal' }}>CÓD</th>
                                                    <th style={{ fontSize: '14px', padding: '15px', fontWeight: 'normal' }}>DOCUMENTO</th>
                                                    <th style={{ fontSize: '14px', padding: '15px', fontWeight: 'normal' }}>EMPRESA</th>
                                                    <th style={{ fontSize: '14px', padding: '15px', fontWeight: 'normal' }}>RESPONSÁVEL</th>
                                                    <th style={{ fontSize: '14px', padding: '15px', fontWeight: 'normal' }}>CADASTRO</th>
                                                    <th style={{ fontSize: '14px', padding: '15px', fontWeight: 'normal' }}>STATUS</th>
                                                    <th style={{ fontSize: '14px', padding: '15px', fontWeight: 'normal' }}>AÇÕES</th>
                                                </tr>
                                            </thead>
                                            
                                            <tbody>
                                                {reapPcmso && reapPcmso.length > 0 ? (
                                                    reapPcmso.map((reapPCMSO: any) => {
                                                        return (
                                                            <tr key={reapPCMSO.id}>
                                                                <td style={{ fontSize: '13px', padding: '15px', fontWeight: 'bold' }}>
                                                                    {reapPCMSO.id}
                                                                </td>
                                                                <td style={{ fontSize: '13px', padding: '15px', fontWeight: 'bold' }}>
                                                                    PCMSO - Reaproveitamento
                                                                </td>
                                                                <td style={{ fontSize: '13px', padding: '15px', fontWeight: 'bold' }}>

                                                                    {reapPCMSO.nome_empresa}
                                                                </td>
                                                                <td style={{ fontSize: '13px', padding: '15px', fontWeight: 'bold' }}>

                                                                    {reapPCMSO.nome_medico}
                                                                </td>
                                                                <td style={{ fontSize: '13px', padding: '15px', fontWeight: 'bold' }}>

                                                                    {formatDate(reapPCMSO.createdAt)}
                                                                </td>
                                                                
                                                                <td style={{ fontSize: '13px', padding: '15px', fontWeight: 'bold', color: reapPCMSO.liberado ? 'green' : 'red' }}>
                                                                    {reapPCMSO.liberado === 0 ? (
                                                                        <>
                                                                            <ExclamationTriangleFill style={{ marginBottom: '5px' }} /> Quarentena
                                                                        </>
                                                                    ) : reapPCMSO.liberado === 1 ? (
                                                                        <>
                                                                            <CheckCircleFill style={{ marginBottom: '1px' }} /> Liberado
                                                                        </>
                                                                    )  : (
                                                                        'Status ainda não estabelecido'
                                                                    )}
                                                                </td>
                                                                
                                                                <td style={{ padding: '16px', textAlign: 'center' }}>
                                                                    <div className="d-flex justify-content-center align-items-center">
                                                                        {reapPCMSO.liberado === 1 ? (
                                                                        <Button 
                                                                            href={`/reaproveitamento-aso/editar-pcmso/${reapPCMSO.id}`} 
                                                                            variant="primary"
                                                                        >
                                                                            <Eye size={20} />
                                                                        </Button>
                                                                        ) : (
                                                                        <Button 
                                                                            href={`/reaproveitamento-aso/editar-pcmso/${reapPCMSO.id}`} 
                                                                            variant="primary"
                                                                        >
                                                                            <Pencil size={20} />
                                                                        </Button>
                                                                        )}
                                                                    </div>
                                                                </td>

                                                            </tr>
                                                        );
                                                    })
                                                ) : (
                                                    <tr>
                                                        <td colSpan={6} style={{ padding: '15px', textAlign: 'center' }}>
                                                            Nenhum documento disponível
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </Row>
                                </>
                            )}
                            

                            {selectedCheckboxTables.length > 0 && (
                                <div style={{ marginTop: '20px', display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end' }}>
                                    <Button style={{ backgroundColor: 'red', color: 'white', border: 'none' }}>
                                        Excluir Selecionados
                                    </Button>
                                </div>
                            )}
                        </Col>
                    </Row>
                </CardContent>
                <Modals show={showModal} onHide={handleClose} size='lg'>
                    <Modals.Header closeButton>
                        <Modals.Title>Selecione uma função para o trabalhador</Modals.Title>
                    </Modals.Header>
                    <Modals.Body style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', margin: 'auto' }}>
                        {funcoes && funcoes.length > 0 ? (
                            <>
                                {funcoes.map((funcao: any) => (
                                    <Grid item key={funcao.ateBaseFuncao.id} style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                                        <Button
                                            onClick={() => handleSelectFuncao(funcao)}
                                            style={{
                                                cursor: 'pointer',
                                                backgroundColor: funcaoSelecionada?.id === funcao.ateBaseFuncao.id ? '#E0F7FA' : '#fff',
                                                border: '2px solid #0463C1',
                                                color: '#0463C1',
                                                width: 'auto',
                                                height: 'auto',
                                                padding: '10px', 
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                textAlign: 'center',
                                                transition: '0.3s',
                                                boxSizing: 'border-box',
                                                fontWeight: '500',
                                            }}
                                            onMouseEnter={(e) => e.currentTarget.style.boxShadow = '0px 4px 10px rgba(0, 0, 0, 0.2)'}
                                            onMouseLeave={(e) => e.currentTarget.style.boxShadow = 'none'}
                                            variant="outlined"
                                        >
                                            <div
                                                style={{
                                                    whiteSpace: 'nowrap',
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    fontSize: '16px',
                                                }}
                                            >
                                                {funcao.ateBaseFuncao.nome}
                                            </div>
                                        </Button>
                                    </Grid>
                                ))}
                                { exames && exames.length > 0 && (
                                    <Row style={{ display: 'flex', justifyContent: 'center', overflowX: 'auto', width: '100%', borderRadius: '6px', border: '1px solid #0d6efd' }}>
                                        <table >
                                            <thead>
                                                <tr style={{ backgroundColor: '#0d6efd', color: 'white' }}>
                                                    <th style={{ fontSize: '15px', padding: '15px', textAlign: 'center', fontWeight: 'normal' }}>Ordem</th>
                                                    <th style={{ fontSize: '15px', padding: '15px', textAlign: 'center', fontWeight: 'normal' }}>Exame</th>
                                                    <th style={{ fontSize: '15px', padding: '15px', textAlign: 'center', fontWeight: 'normal' }}>Valor</th>
                                                
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {exames.map((exame: any, index: number) => {
                                                    return (
                                                        <tr key={exame.id}>
                                                            <td style={{ fontSize: '15px', textAlign: 'center' }}>
                                                                <div>{index + 1}</div>
                                                            </td>
                                                            <td style={{ fontSize: '15px', textAlign: 'center', padding: '6px' }}>
                                                                {exame.ateBaseExames.nome}
                                                            </td>
                                                            <td style={{ fontSize: '15px', textAlign: 'center', padding: '6px' }}>
                                                                {transformarPreco(exame.valor_total)}
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </table>
                                    </Row>
                                )}
                                {funcaoSelecionada && (                                    
                                    <div style={{ display: 'flex', justifyContent: 'center', marginTop: '15px' }}>
                                        <Button 
                                        variant='primary' 
                                        onClick={handleEmitirPagamentoTrabalhador} 
                                        disabled={isLoadingPayment}>
                                            Emitir Pagamento ao Trabalhador
                                        </Button>
                                    </div>
                                )}
                            </>
                        ) : (
                            <Spinner animation="border" />
                        )}
                    </Modals.Body>
                    <Modals.Footer style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                    </Modals.Footer>
                </Modals>
            </Main>
            <AlertMessage
                show={alert.show}
                message={alert.message}
                variant={alert.variant}
                onClose={() => setAlert({ ...alert, show: false })}
            />
        </div >
    );
}